// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-xsmall-superElipse-c9275806","strokeWidth":"super-ellipse-skins-xsmall-strokeWidth-68b76dcc"};